export const navItems = [
  {
    id: 1,
    title: "Home",
    path: "./",
    cName: "nav-item",
  },
  {
    id: 2,
    title: "Products",
    path: "./Products",
    cName: "nav-item",
  },
  {
    id: 3,
    title: "Services",
    path: "./Services",
    cName: "nav-item",
  },
  {
    id: 4,
    title: "Supports",
    path: "./Supports",
    cName: "nav-item",
  },
  {
    id: 5,
    title: "About Us",
    path: "./AboutUs",
    cName: "nav-item",
  },
  {
    id: 6,
    title: "Contact Us",
    path: "./ContactUs",
    cName: "nav-item",
  },
];

export const prodDropdown = [
  {
    id: 1,
    title: "Product Sensor",
    path: "./ProductSensor",
    cName: "submenu-item",
  },
  {
    id: 2,
    title: "Product PCAP Touch",
    path: "./ProductTouch",
    cName: "submenu-item",
  },
  {
    id: 3,
    title: "Product Touch Display",
    path: "./ProductTouchLcm",
    cName: "submenu-item",
  },
  {
    id: 4,
    title: "Touch Control Board",
    path: "./ProductTpCtrlBd",
    cName: "submenu-item",
  },
  {
    id: 5,
    title: "Display AD Board",
    path: "./ProductLcmAdBd",
    cName: "submenu-item",
  },
];


export const suppDropdown = [
  {
    id: 1,
    title: "Sensor Category",
    path: "./SupportSensor",
    cName: "submenu-item",
  },
  {
    id: 2,
    title: "Touch Panel Category",
    path: "./SupportTouch",
    cName: "submenu-item",
  },
  {
    id: 3,
    title: "Touch Display Category",
    path: "./SupportTouchLcm",
    cName: "submenu-item",
  },
  {
    id: 4,
    title: "List Sensors",
    path: "./ListingSensors",
    cName: "submenu-item",
  },
  {
    id: 5,
    title: "List Touch Panels",
    path: "./ListingTouchs",
    cName: "submenu-item",
  },
  // {
    //   id: 6,
  //   title: "crud Sensor",
  //   path: "./CRUDSensors",
  //   cName: "submenu-item",
  // },
  // {
  //   id: 7,
  //   title: "crud Touch Panel",
  //   path: "./CRUDTouchs",
  //   cName: "submenu-item",
  // }
];

export const servDropdown = [
  {
    id: 1,
    title: "Marketing",
    path: "./ServiceMarket",
    cName: "submenu-item",
  },
  {
    id: 2,
    title: "Consulting",
    path: "./ServiceConsult",
    cName: "submenu-item",
  },
  {
    id: 3,
    title: "Design",
    path: "./ServiceDesign",
    cName: "submenu-item",
  },
  {
    id: 4,
    title: "Development",
    path: "./ServiceDevelop",
    cName: "submenu-item",
  },
];
